module.exports = __webpack_public_path__ + "img/small-access.2f8e87db.svg";